import dayjs, { Dayjs } from "utils/dayjs"
import { Guid, IApiLink } from "@/types"
import { ApiLinkEntity, ApiLinkRel } from "config/constants"

export interface IGetAssetVersionDto {
    assetId: Guid
    version: number
    availabilityDate: string
    disposalDate?: string | null
    isCurrentVersion: boolean
    links: IApiLink[]
}

export default class AssetVersion {
    assetId: Guid
    version: number
    availabilityDate: Dayjs
    disposalDate?: Dayjs
    isCurrentVersion: boolean
    linkGetAssetDocuments?: IApiLink
    linkGetAssetMaintenance?: IApiLink

    constructor(dto: IGetAssetVersionDto) {
        this.assetId = dto.assetId
        this.version = dto.version
        this.availabilityDate = dayjs.utc(dto.availabilityDate)
        this.disposalDate = dto.disposalDate ? dayjs.utc(dto.disposalDate) : undefined
        this.isCurrentVersion = dto.isCurrentVersion

        // Try to find document link from API, otherwise construct it from assetId
        this.linkGetAssetDocuments = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.assetDocument && lnk.rel === ApiLinkRel.all)
            ?? {
            href: `/svcasset/asset/${dto.assetId}/document`,
            entity: ApiLinkEntity.assetDocument,
            rel: ApiLinkRel.all,
            method: 'GET' as const,
            templated: false,
        }

        // Try to find maintenance link from API, otherwise construct it from assetId
        this.linkGetAssetMaintenance = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.assetMaintenance && lnk.rel === ApiLinkRel.all)
            ?? {
            href: `/svcasset/asset/${dto.assetId}/maintenance`,
            entity: ApiLinkEntity.assetMaintenance,
            rel: ApiLinkRel.all,
            method: 'GET' as const,
            templated: false,
        }
    }
}
